export default "<template>\n\n  <KTextbox>\n    <template #label>Label via slot</template>\n  </KTextbox>\n\n</template>\n";